import {
  DeleteOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Button,
  GetProp,
  Input,
  message,
  Modal,
  Select,
  Upload,
  UploadProps,
} from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect, useState } from "react";
import { cardData } from "../../scripts/products";

type Props = {
  open?: any;
  isCloseModal?: any;
  item?: any;
};

const ProductModal: React.FC<Props> = ({ open, isCloseModal, item }: Props) => {
  const [product, setProduct] = useState<any>(item);
  const [title, setTitle] = useState<any>("");
  const [description, setDescription] = useState<any>("");
  const [consist, setСonsist] = useState<any>("");
  const [type, setType] = useState<any>(null);
  const [kind, setKind] = useState<any>(null);
  const [gas, setGas] = useState<any>(null);
  const [waterSource, setWaterSource] = useState<any>(null);
  const [pack, setPack] = useState<any>(null);
  const [value, setValue] = useState<any>(null);
  const [unit, setUnit] = useState<any>(null);
  const [price, setPrice] = useState<any>(null);
  const [imageUrl, setImageUrl] = useState<string>();
  const [loading, setLoading] = useState(false);
  let products = cardData;

  useEffect(() => {
    setProduct(item);
  }, [item]);

  const handleInputTitle = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setTitle(event.target.value);
  };

  const handleInputDesc = (event: any): void => {
    setDescription(event.target.value);
  };

  const handleInputСonsist = (event: any): void => {
    setСonsist(event.target.value);
  };

  const handleInputUnit = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setUnit(event.target.value);
  };

  const handleInputPrice = (
    event: React.ChangeEvent<HTMLInputElement>
  ): void => {
    setPrice(event.target.value);
  };

  const closeModal = (isOpen: boolean) => {
    isCloseModal();
  };

  const saveModal = (isOpen: boolean) => {
    let newProduct = {
      id: products.length + 1,
      title,
      description,
      type,
      price,
      seller: "Ново-Ярославский нефтеперерабатывающий завод (Славнефть-ЯНОС)",
    };
    console.log("type", type);
    // @ts-ignore
    products.push(newProduct);
    isCloseModal();
    setTitle("");
    setType(null);
    setDescription("");
    setPrice(null);
    setGas(null);
    setKind(null);
    setUnit(null);
    setPack(null);
    setWaterSource(null);
    setСonsist(null);
    setValue(null);
  };

  type FileType = Parameters<GetProp<UploadProps, "beforeUpload">>[0];

  const getBase64 = (img: FileType, callback: (url: string) => void) => {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result as string));
    reader.readAsDataURL(img);
  };

  const beforeUpload = (file: FileType) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error("Image must smaller than 2MB!");
    }
    return isJpgOrPng && isLt2M;
  };

  const uploadButton = (
    <button style={{ border: 0, background: "none" }} type="button">
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Загрузить фото</div>
    </button>
  );

  const handleChangeImg: UploadProps["onChange"] = (info: any) => {
    if (info.file.status === "uploading") {
      //setLoading(true);
      return;
    }
    if (info.file.status === "done") {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj as any, (url) => {
        setLoading(false);
        setImageUrl(url);
      });
    }
  };

  return (
    <Modal
      title={`${!item ? "Добавить" : "Редактировать"} продукт`}
      open={open}
      onCancel={() => closeModal(false)}
      footer={
        item
          ? [
              <Button key="cancel" onClick={() => closeModal(false)}>
                Отмена
              </Button>,
              <Button
                key="link"
                type="primary"
                onClick={() => closeModal(false)}
              >
                <DeleteOutlined />
                Удалить
              </Button>,
              <Button
                key="link"
                type="primary"
                onClick={() => saveModal(false)}
              >
                Сохранить
              </Button>,
            ]
          : [
              <Button key="cancel" onClick={() => closeModal(false)}>
                Отмена
              </Button>,
              <Button
                key="link"
                type="primary"
                onClick={() => saveModal(false)}
                disabled={
                  !title.length ||
                  !description.length ||
                  price == null ||
                  type == null ||
                  kind == null ||
                  gas == null ||
                  waterSource == null ||
                  value == null ||
                  pack == null ||
                  consist == "" ||
                  unit == null
                }
              >
                Сохранить
              </Button>,
            ]
      }
    >
      <span className="red">Все поля обязательны для заполнения</span>
      <p className="sub_title">Название продукта</p>
      <Input
        type="text"
        placeholder="Введите название продукта"
        value={title}
        name="name"
        onChange={handleInputTitle}
      />
      <p className="sub_title">Описание</p>
      <TextArea
        placeholder="Введите описание"
        value={description}
        name="description"
        rows={4}
        onChange={handleInputDesc}
      />
      <div className="grid-options">
        <p className="sub_title">Стоимость</p>
        <Input
          type="number"
          placeholder="Укажите стоимость"
          value={price}
          name="price"
          onChange={handleInputPrice}
        />

        <p className="sub_title">Тип</p>
        <Select
          value={type}
          onChange={(value) => setType(value)}
          style={{ width: "100%" }}
          allowClear={false}
          options={[{ value: "Вода" }]}
          placeholder="Выберите тип"
          showSearch
        />

        {type != null && (
          <>
            <p className="sub_title">Тип воды</p>
            <Select
              value={kind}
              onChange={(value) => setKind(value)}
              allowClear={false}
              options={[{ value: "Питьевая" }, { value: "Техническая" }]}
              placeholder="Выберите вид воды"
              showSearch
            />
          </>
        )}
        {kind != null && (
          <>
            <p className="sub_title">Газирование</p>
            <Select
              value={gas}
              onChange={(value) => setGas(value)}
              allowClear={false}
              options={[{ value: "Негазированная" }, { value: "Газированная" }]}
              placeholder="Выберите газирование"
              showSearch
            />
          </>
        )}
        {gas != null && (
          <>
            <p className="sub_title">Природный источник</p>
            <Select
              value={waterSource}
              onChange={(value) => setWaterSource(value)}
              allowClear={false}
              options={[{ value: "Артезианская" }]}
              placeholder="Выберите природный источник"
              showSearch
            />
          </>
        )}
        {waterSource != null && (
          <>
            <p className="sub_title">Объем, мл</p>
            <Select
              value={value}
              onChange={(value) => setValue(value)}
              allowClear={false}
              options={[
                { value: "500" },
                { value: "1000" },
                { value: "1500" },
                { value: "2000" },
              ]}
              placeholder="Выберите объем"
              showSearch
            />
          </>
        )}
        {value != null && (
          <>
            <p className="sub_title">Состав</p>
            <TextArea
              placeholder="Введите состав"
              value={consist}
              name="consist"
              rows={4}
              onChange={handleInputСonsist}
            />
          </>
        )}
        <p className="sub_title">Упаковка</p>
        <Select
          value={pack}
          onChange={(value) => setPack(value)}
          allowClear={false}
          options={[
            { value: "Пластиковая бутылка" },
            { value: "Стеклянная бутылка" },
          ]}
          placeholder="Укажите упаковку"
          showSearch
        />
        <p className="sub_title">Единиц товара</p>
        <Input
          type="number"
          placeholder="Укажите число единиц товара"
          value={unit}
          name="unit"
          onChange={handleInputUnit}
        />
        <p className="sub_title">Фото товара</p>
        <Upload
          name="avatar"
          listType="picture-circle"
          className="avatar-uploader"
          showUploadList={true}
          action="https://660d2bd96ddfa2943b33731c.mockapi.io/api/upload"
          beforeUpload={beforeUpload}
          onChange={handleChangeImg}
        >
          {imageUrl ? (
            <img src={imageUrl} alt="avatar" style={{ width: "100%" }} />
          ) : (
            uploadButton
          )}
        </Upload>
      </div>
    </Modal>
  );
};

export default ProductModal;
